var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg24IcMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24_ic_money") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/24_ic_money",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Colors/Grey",
    transform: "translate(6.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.14666667,8.56666667 C3.87666667,7.97666667 3.14666667,7.36666667 3.14666667,6.41666667 C3.14666667,5.32666667 4.15666667,4.56666667 5.84666667,4.56666667 C7.62666667,4.56666667 8.28666667,5.41666667 8.34666667,6.66666667 L10.5566667,6.66666667 C10.4866667,4.94666667 9.43666667,3.36666667 7.34666667,2.85666667 L7.34666667,0.666666667 L4.34666667,0.666666667 L4.34666667,2.82666667 C2.40666667,3.24666667 0.846666667,4.50666667 0.846666667,6.43666667 C0.846666667,8.74666667 2.75666667,9.89666667 5.54666667,10.5666667 C8.04666667,11.1666667 8.54666667,12.0466667 8.54666667,12.9766667 C8.54666667,13.6666667 8.05666667,14.7666667 5.84666667,14.7666667 C3.78666667,14.7666667 2.97666667,13.8466667 2.86666667,12.6666667 L0.666666667,12.6666667 C0.786666667,14.8566667 2.42666667,16.0866667 4.34666667,16.4966667 L4.34666667,18.6666667 L7.34666667,18.6666667 L7.34666667,16.5166667 C9.29666667,16.1466667 10.8466667,15.0166667 10.8466667,12.9666667 C10.8466667,10.1266667 8.41666667,9.15666667 6.14666667,8.56666667 Z",
    id: "Mask"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24IcMoney);
export default __webpack_public_path__ + "static/media/24_ic_money.8ec1233e.svg";
export { ForwardRef as ReactComponent };